import { Box, Flex, Pagination } from '@cowsquare/design';
import { Link } from 'gatsby';
import gql from 'graphql-tag';
import { ellipsis } from 'polished';
import * as R from 'ramda';
import React from 'react';
import { Query } from 'react-apollo';
import { Helmet } from 'react-helmet';
import styled from 'styled-components';
import { space } from 'styled-system';
import { themeGet } from '@styled-system/theme-get';
import defaultCover from '../../../../asset/defaultCover.jpg';
import { dateFormat } from '../../../../utils/dateFormat';
import { getQueryObject } from '../../../../utils/getQueryObject';
import { usePagesBindingUrl } from '../../../../utils/hooks';
import { Advertisements } from '../../../Advertisements';
import { Section } from '../../../Section';
import { Title } from '../../../Title';

const PAGE_SIZE = 20;

const GalleryFlex = styled(Flex).attrs({
  flexWrap: 'wrap',
  mx: '-8px',
  mb: 7,
})`
  ${space}
`;

const GalleryBox = styled(Box).attrs({
  width: [1 / 2, 1 / 4],
  px: 4,
  pb: 7,
})`
  display: inline-block;
`;

const Cover = styled.div`
  width: 100%;
  background-color: ${themeGet('album.cover.backgroundColor')};
  background-image: url(${props => props.src});
  background-repeat: no-repeat;
  background-position: center center;
  background-size: cover;
  cursor: pointer;

  &:after {
    content: '';
    display: block;
    padding-bottom: 100%;
  }

  &:hover {
    filter: brightness(80%);
  }
`;

const Name = styled(Box).attrs({
  mt: 4,
  mb: 3,
})`
  ${ellipsis()}
  font-size: 16px;
  line-height: 1.5;
  font-weight: 600;
  cursor: pointer;
`;

const Date = styled.div`
  font-size: 13px;
  line-height: 1.54;
  color: ${themeGet('album.date.color')};
`;

const GET_MEMBERS_ALBUMS = gql`
  query hkdutest_members_albums($limit: Int, $offset: Int) {
    total: hkdutest_members_albums_aggregate {
      aggregate {
        count
      }
    }
    list: hkdutest_members_albums(limit: $limit, offset: $offset, order_by: { date: desc }) {
      id
      name
      date
      photos(limit: 1) {
        file {
          link
        }
      }
    }
  }
`;

const Album = ({
  location,
  uri,
  // TODO: add advertisement
  ads = [
    {
      href: 'http://google.com',
      title: 'Title',
      description: 'Description',
      imgUrl:
        'https://images.unsplash.com/photo-1450101499163-c8848c66ca85?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1050&q=80',
    },
  ],
}) => {
  const queryObject = getQueryObject(location);
  const [page, onPageChange] = usePagesBindingUrl(queryObject, uri);

  return (
    <Query query={GET_MEMBERS_ALBUMS} variables={{ limit: PAGE_SIZE, offset: (page - 1) * PAGE_SIZE }}>
      {({ data }) => {
        const albums = R.pathOr([], ['list'], data);
        const total = R.pathOr(0, ['total', 'aggregate', 'count'], data);
        return (
          <Section>
            <Helmet>
              <title>Union Album - HKDU Members Only</title>
            </Helmet>
            {/* TODO: add advertisement */}
            <Advertisements ads={ads} />
            <Flex justifyContent="center">
              <Box width={1} mx={[5, 'auto']}>
                <Title mt={8} mb={6}>
                  Union Album
                </Title>
                <GalleryFlex>
                  {albums.map(album => (
                    <GalleryBox key={album.id}>
                      <Link to={`/member-only/album/${album.id}`}>
                        <Cover src={R.pathOr(defaultCover, ['photos', 0, 'file', 'link'], album)} />
                      </Link>
                      <Name>{album.name}</Name>
                      <Date>{dateFormat(album.date)}</Date>
                    </GalleryBox>
                  ))}
                </GalleryFlex>
              </Box>
              {total > PAGE_SIZE && (
                <Box mb={8}>
                  <Pagination total={total} pageSize={PAGE_SIZE} current={page} onChange={onPageChange} />
                </Box>
              )}
            </Flex>
          </Section>
        );
      }}
    </Query>
  );
};

export default Album;
